const experimentSearchConstants = {
  FETCH_SCORE_CARDS: "expSearchApp/FETCH_SCORE_CARDS",
  LOAD_EXP_SEARCH: "expSearchApp/LOAD_EXP_SEARCH",
  GET_ALL_SCORECARDS: "expSearchApp/GET_ALL_SCORECARDS",
  GET_ALL_EXPS: "expSearchApp/GET_ALL_EXPS",
  LOAD_MGMT_GRP: "expSearchApp/LOAD_MGMT_GRP",
  LOAD_ISOLATION_GROUPS: "expSearchApp/LOAD_ISOLATION_GROUPS",
  LOAD_OTHER_SEARCH_FIELDS: "expSearchApp/LOAD_OTHER_SEARCH_FIELDS",
  LOAD_SUB_MGMT_GRPS: "expSearchApp/LOAD_SUB_MGMT_GRPS",
  UPDATE_MGMT_GROUPS: "expSearchApp/UPDATE_MGMT_GROUPS",
  UPDATE_ISOLATION_GROUPS: "expSearchApp/UPDATE_ISOLATION_GROUPS",
  UPDATE_OTHER_SEARCH_FIELDS: "expSearchApp/UPDATE_OTHER_SEARCH_FIELDS",
  UPDATE_SUB_MGMT_GRPS: "expSearchApp/UPDATE_SUB_MGMT_GRPS",
  HANDLE_SUB_MGMT_STATE: "expSearchApp/HANDLE_SUB_MGMT_STATE",
  LOAD_STATUS_DATA: "expSearchApp/LOAD_STATUS_DATA",
  UPDATE_STATUS_DATA: "expSearchApp/UPDATE_STATUS_DATA",
  UPDATE_SELECTED_VALUES: "expSearchApp/UPDATE_SELECTED_VALUES"
};
export {
  experimentSearchConstants as default
};
//# sourceMappingURL=ExperimentSearchConstants.js.map
